// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CompanyPageView_wrapper__2E8gm","title":"CompanyPageView_title__NKj9G"};